import { useLocation } from "react-router-dom";

export default function SuccessPage() {

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const invoice = params.get("invoice");

  return (
    <div className="text-center py-24 px-4">
      <h1 className="text-4xl font-bold mb-4 text-green-600">Thank you for your order!</h1>
      <p className="text-lg text-gray-700 mb-2">
        Your order was placed successfully.
      </p>
      {invoice && (
        <p className="text-sm text-gray-500 mb-6">
          Invoice ID: <span className="font-mono">{invoice}</span>
        </p>

      )}
      <a
        href="/category/women"
        className="inline-block bg-black text-white px-6 py-3 rounded hover:bg-gray-800"
      >
        Continue Shopping
      </a>
    </div>
  );
}
